import { render } from "./LegendUpDownTick.vue?vue&type=template&id=23bdfdfe&scoped=true"
import script from "./LegendUpDownTick.vue?vue&type=script&lang=js"
export * from "./LegendUpDownTick.vue?vue&type=script&lang=js"

import "./LegendUpDownTick.vue?vue&type=style&index=0&id=23bdfdfe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bdfdfe"]])

export default __exports__